// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "scripts/" + ({"308":"burger","348":"footer","362":"brand","411":"nav","494":"camelCase","582":"modal","672":"watch","768":"page"}[chunkId] || chunkId) + ".js";
};